// extracted by mini-css-extract-plugin
module.exports = {"heading":"_69GQ8W1Of-hmmNXGGa5Zgw==","parent":"GgO-wVcqX8AtWiQQZ6O2dA==","navbar-text":"X-tdq0QGSu3CPB2to-Wx+w==","icon":"-KRL3WKL3Tvg7cAak2WxMw=="};